import { UserGroups } from 'pages/TeamMembers/const'

export interface AccountType {
  id: number
  name: string
  isCurrent: boolean
  reference: string
  status?: string
}

export type UserGroupType = keyof typeof UserGroups

export interface AccountUserGroup {
  id: number
  name: UserGroupType
}

export interface AccountUser {
  id: number
  emailAddress: string
  groups: AccountUserGroup[]
  name?: string
  approver?: boolean
  isWorkspaceOwner?: boolean
}

export const AccountStatus = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
} as const

export type AccountStatus = keyof typeof AccountStatus
